import React from "react";
import { useTranslation } from "react-i18next";
import "./Modal.css";
import "./ShareModal.css";

const ShareModal = ({ store, shareUrl, onClose, copied, onCopy, sendStatus, onSend }) => {
  const { t } = useTranslation();
  if (!shareUrl) return null;
  return (
    <div className="dispatch-modal-backdrop" onClick={onClose}>
      <div className="dispatch-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dispatch-modal-header">
          <span className="dispatch-modal-title">{t("SHARE_SCHEDULE_TITLE")} — {store && store.name}</span>
          <button className="dispatch-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="dispatch-share-content">
          <div className="dispatch-share-url-row">
            <input className="dispatch-share-url-input" readOnly value={shareUrl} />
            <button className={"dispatch-share-copy-btn" + (copied ? " copied" : "")} onClick={onCopy}>
              {copied ? t("COPIED") : t("COPY")}
            </button>
          </div>
          <p className="dispatch-share-expiry-hint">{t("SHARE_LINK_EXPIRY_HINT")}</p>
          <div className="dispatch-share-actions">
            <div>
              {sendStatus === "sent" && <span className="dispatch-share-sent-msg">{t("EMAIL_SENT_TO")} {store && store.email}</span>}
              {sendStatus === "error" && <span className="dispatch-share-error-msg">{t("FAILED_TO_SEND_EMAIL")}</span>}
            </div>
            <button
              className="dispatch-modal-track-btn"
              onClick={onSend}
              disabled={sendStatus === "sending" || sendStatus === "sent"}
            >
              {sendStatus === "sending" ? t("SENDING") : sendStatus === "sent" ? t("SENT") : t("SEND_TO_STORE")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
